import React from 'react';
import { useTelephonyContext } from '../../../../../contexts/TelephonyContext';
import { TelephonyWidgetContainer } from '../../../../../models/TelephonyWidgetContainer';
import ChevronIcon from '../../../Icons/ChevronIcon';
import { Button } from '@coolblue-development/freddy';

const BackButton = (): JSX.Element => {
  const { setActiveTelephonyWidgetContainer, voiceContact } = useTelephonyContext();

  const handleBackClick = (): void => {
    setActiveTelephonyWidgetContainer(voiceContact ? TelephonyWidgetContainer.CALL : TelephonyWidgetContainer.OUTBOUND);
  };

  return (
    <>
      <Button
        sx={{ color: '#fff', fontWeight: '100', ':hover': { background: 'none' } }}
        data-testid="back-button"
        startIcon={<ChevronIcon rotation={0} />}
        onClick={handleBackClick}
        variant="tertiary"
      >
        Back
      </Button>
    </>
  );
};

export default BackButton;
